import { Grid, InputLabel, makeStyles, TextField } from "@material-ui/core";
import Form from "@saleor/components/Form";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { maybe } from "@saleor/misc";
import { OrderCourierEnum } from "@saleor/motherOrders/utils/enums";
import { disableDimWeightNationwide } from "@saleor/motherOrders/utils/handlers";
import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import * as React from "react";

import { ManualRebookingInitialFormData } from "../types";

const useStyles = makeStyles(
  () => ({
    content: {
      marginBottom: "17px"
    },
    dimensions: {
      marginBottom: "6px"
    },
    riderDetails: {
      alignItems: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "left"
    },
    riderDetailsContent: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      fontSize: "17px",
      marginBottom: "6px"
    },
    sectionLabel: {
      margin: "0px",
      marginBottom: "6px",
      marginLeft: "5px"
    }
  }),
  { name: "TwoGoRider" }
);

interface TwoGoRiderProps {
  initialForm: ManualRebookingInitialFormData;
  status: SmopOrderStatusEnum;
  homeLocation?: any;
  isOnGoingBooking?: boolean;
  rider?: any;
  failedReason?: any;
  weight: any;
  length: any;
  width: any;
  height: any;
  setWeight: React.Dispatch<React.SetStateAction<string>>;
  setLength: React.Dispatch<React.SetStateAction<string>>;
  setWidth: React.Dispatch<React.SetStateAction<string>>;
  setHeight: React.Dispatch<React.SetStateAction<string>>;
}

const TwoGoRider: React.SFC<TwoGoRiderProps> = props => {
  const {
    initialForm,
    status,
    rider,
    length,
    width,
    weight,
    height,
    setLength,
    setWidth,
    setWeight,
    setHeight
  } = props;
  const classes = useStyles(props);

  const riderChoices = maybe(
    () => [
      {
        label: `2GO Manual`,
        value: OrderCourierEnum.O2GO
      }
    ],
    []
  );

  const disableDimWeight = disableDimWeightNationwide(
    rider?.order?.deliveryCourier?.failedReason
  );

  initialForm.courier = OrderCourierEnum.O2GO;
  return (
    <div>
      <Form initial={initialForm} confirmLeave>
        {({ data: formData, change }) => (
          <>
            <h3 className={classes.sectionLabel}>
              {" "}
              <InputLabel
                htmlFor="courier"
                required
                style={{ color: "black", fontWeight: 600 }}
              >
                Courier
              </InputLabel>
            </h3>
            <div className={classes.content}>
              <SingleSelectField
                label={"select courier"}
                onChange={change}
                choices={riderChoices}
                name="courier"
                value={formData.courier}
                selectProps={{ required: true }}
                disabled={
                  status === SmopOrderStatusEnum.CANCELED ||
                  status === SmopOrderStatusEnum.COMPLETED
                }
              />
            </div>

            <h3 className={classes.sectionLabel}>Dimensions</h3>
            <div className={classes.riderDetails}>
              <div className={classes.content}>
                <div className={classes.dimensions}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        id="weightTxt"
                        label={"Weights(kg)"}
                        variant="outlined"
                        required
                        name="packageWeight"
                        type="number"
                        value={weight}
                        onChange={event => {
                          setWeight(event.target.value.toString());
                        }}
                        fullWidth
                        disabled={disableDimWeight}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        id="lengthTxt"
                        label={"Length(cm)"}
                        variant="outlined"
                        required
                        name="packageLength"
                        type="number"
                        value={length}
                        onChange={event => {
                          setLength(event.target.value.toString());
                        }}
                        fullWidth
                        disabled={disableDimWeight}
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>

              <div className={classes.content}>
                <div className={classes.dimensions}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        id="widthTxt"
                        label={"Width(cm)"}
                        variant="outlined"
                        name="packageWidth"
                        type="number"
                        required
                        value={width}
                        onChange={event => {
                          setWidth(event.target.value.toString());
                        }}
                        fullWidth
                        disabled={disableDimWeight}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        id="heightTxt"
                        label={"Height(cm)"}
                        variant="outlined"
                        name="height"
                        required
                        value={height}
                        type="number"
                        onChange={event => {
                          setHeight(event.target.value.toString());
                        }}
                        fullWidth
                        disabled={disableDimWeight}
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>

            <h3 className={classes.sectionLabel}>Airway Bill</h3>
            <div className={classes.riderDetails}>
              <div className={classes.content}>
                <TextField
                  id="airwayBillTxt"
                  label={"Airway Bill"}
                  variant="outlined"
                  fullWidth
                  value={formData.airwayBill}
                  onChange={event => {
                    setWidth(event.target.value.toString());
                  }}
                  disabled
                />
              </div>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

export default TwoGoRider;
